/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'redux';
import { sentencesSaga } from './sagas';
import sentenceSlice, { SENTENCE_KEY_IN_STORE } from './slice';

export class SentenceModule {
	getRootKeyInStore(): string {
		return SENTENCE_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return sentenceSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return sentencesSaga;
	}
}

export const moduleInstance = new SentenceModule();
